import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import WhatsAppFAB from "./components/WhatsAppFAB";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import IndustrialAuthority from "./pages/IndustrialAuthority";

function ScrollToAnchor() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // Legacy /products and /contact routes scroll to the right anchor
    const map = { "/products": "services", "/services": "services", "/contact": "contact" };
    const targetId = hash ? hash.replace("#", "") : map[pathname];
    if (targetId) {
      requestAnimationFrame(() => {
        const el = document.getElementById(targetId);
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - 88;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      });
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [pathname, hash]);
  return null;
}

// Stand-alone wrapper for campaign / landing pages (no main header/footer,
// but keep the WhatsApp FAB + Sonner toaster).
function CampaignShell({ children }) {
  return (
    <div className="min-h-screen bg-[#0B0F19] text-white font-body antialiased">
      {children}
      <WhatsAppFAB />
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#131826",
            border: "1px solid rgba(244,123,32,0.4)",
            borderRadius: 0,
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToAnchor />
        <Routes>
          {/* Campaign / standalone landing pages */}
          <Route
            path="/industrial-authority"
            element={
              <CampaignShell>
                <IndustrialAuthority />
              </CampaignShell>
            }
          />

          {/* Main brand site */}
          <Route
            path="/"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/services"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/products"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="/contact"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path="*"
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
